<template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm">
              <span class="float-end">
                <!-- a class="mr-4 btn btn-link" target="_blank" :href="`${finalPDFLink}`"><i class="fas fa-file-pdf"></i> Download as PDF</a -->
                <div ref="summary"></div>
              </span>
            </div>
          </div>
          <div class="row" v-for="(data, index) in fullsummarymetric.target" v-bind:key="index">
            <div class="col-lg-6">
              <div class="card mb-4">
                <div class="card-header text-center">
                 {{ index }} (Target)
                </div>
                <div class="card-body">
                  <BarChartSummary v-bind:summaryData="data" v-bind:summaryIndex="index" v-bind:maxVal="compileMax(index)" />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card mb-4">
                <div class="card-header text-center">
                  {{ index }} (Baseline)
                </div>
                <div class="card-body">
                  <BarChartSummary v-bind:summaryData="fullsummarymetric.baseline[index]" v-bind:summaryIndex="index" v-bind:maxVal="compileMax(index)" />
                </div>
              </div>
            </div>
          </div>
            <!-- end loop -->
          
          <!-- start pdf -->
          <!-- vue3-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :filename="this.sociometricfilename"
            :pdf-quality="1.5"
            :manual-pagination="true"
            pdf-content-width="800px"
            pdf-format="a4"
            pdf-orientation="portrait"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf" 
        >
        <template  v-slot:pdf-content>
            <div slot="pdf-content" style="padding: 30px; margin: auto; font-size: 80%;">
            <div>
              <div>
                <h3>{{this.passedData}} Summary Sociometrics (pdf)</h3>
              </div>
            </div>
            <div>
            <div v-for="(data, index) in fullsociometric" class="pdf-item w-85">
              <div class="card m-1">
                <div class="card-body">
                  <div class="container-fluid">
                    <div class="row">
            <div class="col-lg-6">
              <div class="card mb-4" v-for="(data, index) in fullsummarymetric.target">
                <div class="card-header text-center">
                 {{ index }} (Target)
                </div>
                <div class="card-body">
                  <BarChartSummary v-bind:summaryData="data" v-bind:summaryIndex="index" />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card mb-4" v-for="(data, index) in fullsummarymetric.baseline">
                <div class="card-header text-center">
                  {{ index }} (Baseline)
                </div>
                <div class="card-body">
                  <BarChartSummary v-bind:summaryData="data" v-bind:summaryIndex="index" />
                </div>
              </div>
            </div>
            </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        </template>
        </vue3-html2pdf -->
          <!-- end pdf -->
        </div>
</template>
<script>
import BarChartSummary from "./FullBarChartSummary.vue";
//import Vue3Html2pdf from 'vue3-html2pdf';
import axios from "axios";
import { onMounted, ref, defineAsyncComponent } from "vue";
export default {
  name: "app",
  components: { BarChartSummary },
  //components: { BarChartSummary, Vue3Html2pdf },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      fullsummarymetric: [],
      testDataElem: null,
      summaryData: null,
      summaryDataIndex: null,
      finalPDFLink: '',
      btnText: '<i class="fas fa-file-pdf"></i> Download as PDF'
    };
  },
  methods: {
  async generateReport () {
      this.btnText = '<i class="fas fa-spinner fa-spin-pulse"></i> Generating PDF...';
      this.btnActive = true;
      // this.$refs.html2Pdf.generatePdf()
    },
    compileMax(index) {
      var finpercent = 0;
      this.fullsummarymetric.baseline[index].forEach(value => {
        if(finpercent < value[1]) {
          finpercent = value[1];
        };
      });
      this.fullsummarymetric.target[index].forEach(value => {
        if(finpercent < value[1]) {
          finpercent = value[1];
        };
      });
      return Math.ceil(finpercent / 10) * 10;
    }
  },
  mounted() {
    const reportName = this.passedData;
    axios
      .get("/user_report", {
        params: {
          report: "appended-" + reportName + ".csv.serializedSummaryResults.json",
          format: "raw",
          objid: "summaryjson",
        },
      })
      .then((response) => {
        this.fullsummarymetric = response.data;
        // console.log('FULL SOCIO RETURN '+JSON.stringify(response.data));
        var finalfile = reportName + ".csv.summarySociometrics.printable.pdf";
        this.finalPDFLink = '/user_report?report=' + finalfile;
        //const printable = reportName + ".csv.summarySociometrics.printable.pdf";
        const s = '<a class="mr-4 btn btn-link" target="_blank" href="/user_report?report=' + finalfile + '" download="' + finalfile + '"><i class="fas fa-file-pdf"></i> Download as PDF</a><a class="mr-4 btn btn-link" target="_blank" href="/user_dataset?dataset=appended-' + reportName + '.csv.serializedSummaryResults.csv&format=raw&objid=null"><i class="fas fa-file-csv"></i> Download as CSV</a>';
        this.$refs["summary"].innerHTML = s;
      }).catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
      });
  },
};
</script>
